import { connect } from 'react-redux';

import { IState } from '../../store';
import { getHittingMicrodataExperiment } from '../../utils/microdata_experiment';
import { Geo, IGeoProps } from './index';

function mapStateToProps(state: IState): IGeoProps {
  return {
    isMicrodataExperimentEnable: getHittingMicrodataExperiment(state.experiments),
    offer: state.offerData.offer,
  };
}

// tslint:disable-next-line:no-any
export const GeoContainer = connect<IGeoProps, any, any>(
  mapStateToProps,
)(Geo);
